import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/eclips/templates'
const plural = 'eclip'
const single = 'eclip'

const api = new ApiCore({
	index: true,
	create: true,
	url: url,
	plural: plural,
	single: single
})

api.index = (options) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`, options)
		.then(handleResponse)
		.catch(handleError);
}

export default api
